export default [
  {
    path: 'filiais',
    name: 'branchs',
    component: () => import(/* webpackChunkName: "branchs" */ './Index.vue'),
    meta: {
      title: 'Filiais',
      icon: 'mdi-store',
      admin: true
    }
  },
  {
    path: 'filiais/:id',
    name: 'branchs.view',
    component: () => import(/* webpackChunkName: "branchs" */ './View.vue'),
    meta: {
      title: 'Filial',
      icon: 'mdi-store',
      admin: true
    }
  }
];
